<template>
  <div class="purple-round-input input-wrapper" :class="{ error }">
    <input
      class="w-full h-12 outline-none"
      :class="{ disabled: disabled }"
      type="text"
      ref="input"
      :required="required"
      :inputmode="inputmode"
      :value="value"
      :placeholder="placeholder"
      :disabled="disabled"
      @input="onInput"
      @blur="onInput"
    />
  </div>
</template>

<script>
export default {
  name: 'TextField',
  props: {
    error: Boolean,
    required: Boolean,
    placeholder: String,
    inputmode: String,
    value: String,
    disabled: Boolean,
  },
  mounted() {},
  methods: {
    onInput($event) {
      const { value } = $event.target;
      if (this.required) {
        this.$emit('update:error', !value.trim());
      }
      this.$emit('input', value.trim());
    },
  },
};
</script>

<style lang="scss" scoped>
.input-wrapper {
  @apply pl-6 pr-2;
  &.error {
    border-color: red;
  }
  input {
    background: none;
  }
}
</style>
